import { TabsPanelId, useSplitView } from '@/app/_common/split-view/split-view-context'
import { createWorkflowTab } from '@/app/_common/split-view/tabs/factories'
import { TabTypeStatic } from '@/app/_common/split-view/tabs/types'
import { WaitingIcon } from '@/components/icons/waiting-icon'
import { TooltipIconButton } from '@/components/ui/tooltip-icon-button'
import { SquareArrowOutUpRightIcon } from 'lucide-react'
import React from 'react'

interface EnrichmentProgressProps {
  latestUpdate: string | null
  isEnriching: boolean
  workflowId?: string
}

export const EnrichmentProgress: React.FC<EnrichmentProgressProps> = ({
  latestUpdate,
  isEnriching,
  workflowId,
}) => {
  const { addTab, getTabPositionMetadata } = useSplitView()

  const getOppositePanelId = React.useCallback(() => {
    const position = getTabPositionMetadata({ tabType: TabTypeStatic.DataCatalog })
    return position?.panelId === TabsPanelId.Right ? TabsPanelId.Left : TabsPanelId.Right
  }, [getTabPositionMetadata])

  const handleOpenWorkflow = () => {
    if (workflowId) {
      addTab({
        tab: createWorkflowTab({ workflowId, title: 'Enrichment Workflow' }),
        panelId: getOppositePanelId(),
      })
    }
  }

  if (!isEnriching) {
    return null
  }

  return (
    <div className='flex items-center gap-2'>
      <div className='flex w-[575px] items-center gap-2 border border-neutral-75 p-2'>
        <WaitingIcon className='size-6 shrink-0 rounded-full bg-warning-50 text-warning-300' />
        <div className='flex w-full items-center justify-between text-sm text-neutral-700'>
          {latestUpdate ? (
            <span className='min-w-0 flex-1 truncate'>{latestUpdate}</span>
          ) : (
            <span>Enrichment workflow started successfully</span>
          )}
          {workflowId && (
            <TooltipIconButton
              size='auto'
              className='size-6 text-neutral-150'
              onClick={handleOpenWorkflow}
              titleString='Open workflow'
            >
              <SquareArrowOutUpRightIcon className='size-4 shrink-0' />
            </TooltipIconButton>
          )}
        </div>
      </div>
    </div>
  )
}
